import React, { useState } from "react";

import { Button, Link, Modal } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { CommonTypes } from "@assets/types";

type QuoteApprovalModalProps = {
  approveQuote: CommonTypes.OneParamCallbackFunction<string>;
  quoteReference: string;
};

const QuoteApprovalModal = ({
  approveQuote,
  quoteReference,
}: QuoteApprovalModalProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleApproveQuote = () => {
    approveQuote(quoteReference);
    closeModal();
  };
  return (
    <>
      <Button onClick={openModal}>{t("LABEL_APPROVE")}</Button>
      <Modal
        closeIcon
        closeOnOutsideClick
        onClose={closeModal}
        open={isModalOpen}
        primaryButtonProps={{
          onClick: handleApproveQuote,
          children: t("LABEL_ACCEPT_AND_APPROVE"),
        }}
        secondaryButtonProps={{
          onClick: closeModal,
          children: t("LABEL_CANCEL"),
        }}
        size="small"
        title={t("LABEL_APPROVE_QUOTE")}
      >
        {`${t("TEXT_ACCEPT_TERMS")} `}
        <Link href={t("LABEL_TERMS_URL")} target="_blank">
          {t("LABEL_TERMS_URL_DESCRIPTION")}
        </Link>
      </Modal>
    </>
  );
};

export default QuoteApprovalModal;
